module.exports = __webpack_public_path__ + "img/lageplan_960.73b26954.png";